export const RegionsListKey = 'regions-list';
export const RegionsByZoneKey = 'regions-by-zone';
export const RegionKey = 'region';
export const ZoneNodeCountKey = 'zone-node-count';
export const ZoneServiceCountKey = 'zone-service-count';
export const ZoneUserCountKey = 'zone-user-count';
export const ZoneSummaryKey = 'zone-summary';
